import { jsx, jsxs } from "react/jsx-runtime";
import { useContext, useCallback } from "react";
import PropTypes from "prop-types";
import { Icon } from "../icon/icon.es.js";
import { SegmentedControlItemWrapper, SegmentedControlItemClickArea, SegmentedControlItemInner, SegmentedControlIcon, SegmentedControlText } from "./segmented-control-item.styles.es.js";
import { segmentedControlContext } from "./segmented-control-context.es.js";
import { Tooltip } from "../tooltip/tooltip.es.js";
import "@reach/auto-id";
import { useKeyboardShortcut } from "../../hooks/use-keyboard-shortcut.es.js";
import "styled-components";
import "lodash/fp";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  keyboardShortcut: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
const defaultProps = {
  as: void 0,
  children: void 0,
  icon: void 0,
  keyboardShortcut: void 0,
  subtitle: void 0,
  title: void 0
};
const SegmentedControlItem = ({
  as,
  children,
  icon,
  keyboardShortcut,
  subtitle,
  title,
  value,
  ...restProps
}) => {
  const ref = useKeyboardShortcut({
    predicate: keyboardShortcut,
    callback: () => ref.current.click()
  });
  const {
    disabled,
    magnitude,
    setValue,
    value: selectedValue,
    widthMode
  } = useContext(segmentedControlContext);
  const onClick = useCallback(() => {
    if (setValue) {
      setValue(value);
    }
  }, [setValue, value]);
  return /* @__PURE__ */ jsx(SegmentedControlItemWrapper, { $widthMode: widthMode, children: /* @__PURE__ */ jsx(
    Tooltip,
    {
      disabled: !title,
      justify: "center",
      placement: "top",
      subtitle,
      title,
      children: /* @__PURE__ */ jsx(
        SegmentedControlItemClickArea,
        {
          ref,
          as,
          "aria-disabled": disabled,
          "aria-label": title,
          "aria-selected": value === selectedValue,
          "data-testid": `segmented-control-item__${value}`,
          onClick: !disabled ? onClick : void 0,
          ...restProps,
          children: /* @__PURE__ */ jsxs(SegmentedControlItemInner, { magnitude, children: [
            icon && (typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { magnitude, type: icon }) : /* @__PURE__ */ jsx(SegmentedControlIcon, { magnitude, children: icon })),
            children && /* @__PURE__ */ jsx(SegmentedControlText, { children })
          ] })
        }
      )
    }
  ) });
};
SegmentedControlItem.propTypes = propTypes;
SegmentedControlItem.defaultProps = defaultProps;
export {
  SegmentedControlItem
};
